window.addEventListener("load", () => {
    const videoContainers = document.querySelectorAll('[data-video-container]');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const container = entry.target;
            const video = container.querySelector('video');
            const playButton = container.querySelector('[data-play-video]');

            // Lazy-load high-res poster when video container enters viewport
            if (video && video.dataset.poster) {
                video.poster = video.dataset.poster;
            }

            // Add click listener for native video play button
            if (playButton && video && !playButton.dataset.listenerAdded) {
                playButton.addEventListener('click', () => {
                    video.play();
                    playButton.dataset.playing = 'true';

                    if (!video.loop) {
                        video.addEventListener('ended', () => {
                            playButton.dataset.playing = 'false';
                        }, { once: true });
                    }
                });

                playButton.dataset.listenerAdded = 'true';
            }

            observer.unobserve(container);
        });
    });

    videoContainers.forEach(container => observer.observe(container));
});
